import React from "react";
// import "./1099MasterfileTable.css"
import "../../GlobalCss/SPF/1099MasterfileTable.css"
import { useState, useEffect } from "react";
import { Form, Input, Popconfirm, Table, Typography, Button, Select, Spin, Image, Tooltip, DatePicker } from 'antd';
import {
    SendOutlined, EditOutlined, CheckOutlined, CloseOutlined, ReloadOutlined, LoadingOutlined, ExclamationCircleOutlined,
    SearchOutlined, CheckCircleOutlined
} from "@ant-design/icons";
import { getPayrollData, refreshPayrollData, updateMFRow, ValidateRecord, downloadMontlyData } from "../../Repository/TenNinetyNineRepository";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
import { BaseUrl, JsonConfig, jwtToken } from "../../Repository/BaseRepository";
import axios from "axios";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const MasterfileTable = ({ tableLoader, griddata, setGriddata, setTableLoader, weekendDates, setWeekendDates,onSelectChange,                // ✅ Accept this from parent
    selectedValidatedRows 
     }) => {
        const rowSelection = {
            selectedRowKeys: selectedValidatedRows.map(row => row.key),  // assumes row.key is unique
            onChange: (newSelectedRowKeys, newSelectedRows) => {

              if (onSelectChange) {
                onSelectChange(newSelectedRowKeys, newSelectedRows);
              }
            },
          };
          
    const originalData = griddata;
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const [rowData, setRowData] = useState([]);
    const [searchRow, setSearchRow] = useState("")
    const [filteredData, setFilteredData] = useState(griddata);
    //const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [syncSpin, setSyncSpin] = useState(false)
    const [fromDate, setFromDate] = useState()
    const [documnetDate, setDocumentDate] = useState()
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()
    const [validateSpin, setValidateSpin] = useState(false)
    const [monthLoader, setMonthLoader] = useState(false)
    const [validateLoader, setValidateLoader] = useState(false)
    const isEditing = (record) => record.id === editingKey;
    const [selectedYearMonth, setSelectedYearMonth] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedMonthYear, setSelectedMonthYear] = useState('');
    //const [selectedValidatedRows, setSelectedValidatedRows] = useState([]);

  

    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
 
    
    
    useEffect(() => {
        const fetchInitialData = async () => {
            setTableLoader(true);
            const res = await getPayrollData(); // Call without monthYear
            if (res !== null) {
                setGriddata(res[0] || []);
                setWeekendDates(res[1] || []);
            }
            setTableLoader(false);
        };
    
        fetchInitialData(); // Call API on initial load
    }, []);
    
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.Client)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Client_Type)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Payroll_Name).toLowerCase().includes(value.toLowerCase())
            );
        },
    });

    const changeStartDate = (e) => {
        let sample = new Date(e)
        if (e !== null) {
            const day = String(sample.getDate()).padStart(2, '0');
            const month = String(sample.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = sample.getFullYear();
            const formattedDate = `${month}/${day}/${year}`;
            const value = dayjs(formattedDate, 'MM/DD/YYYY');
            setFromDate(value)
            setStartDate(sample)
        }
        else {
            setFromDate()
            setStartDate()
        }
    }
    const changeDocumentDate = (e) => {
        let sample = new Date(e)
        if (e !== null) {
            const day = String(sample.getDate()).padStart(2, '0');
            const month = String(sample.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = sample.getFullYear();
            const formattedDate = `${month}/${day}/${year}`;
            const value = dayjs(formattedDate, 'MM/DD/YYYY');
            setDocumentDate(value)
            setEndDate(sample)
        }
        else {
            setDocumentDate()
            setEndDate()
        }
    }
    const columns = [
        {
            title: 'PORTAL',
            key: 'Client_Type',
            dataIndex: 'Client_Type',
            // editable: true,
            width: 150,
            ...filterProps(),
        },
        {
            title: 'CLIENT',
            key: 'Client',
            dataIndex: 'Client',
            width: 200,
            // editable: true,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'PAYROLL NAME',
            key: 'Payroll_Name',
            dataIndex: 'Payroll_Name',
            // editable: true,
            width: 220,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        // {
        //     title: 'TIMECARD STATUS',
        //     key: 'Status',
        //     dataIndex: 'Status',
        //     // editable: true,
        //     width: 190,
        //     ellipsis: true,
        //     render: (text, record, index) => (
        //         <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
        //     )
        // },
        ...weekendDates.map(date => ({
            title: date.Weekend,
            children: [
                {
                    title: "RT",
                    ellipsis: true,
                    width: 100,
                    render: (text, record) => {
                        const rtValue = record.weekends[date.Weekend]?.RT || "0"  // Default to '0' if not available
                        // console.log(record)
                        return rtValue;
                    },
                    onCell: (record) => ({
                        record,
                        dataIndex: record.weekends[date.Weekend]?.RT,
                        title: "RT",
                        key: record.id,
                    }),
                },
                {
                    title: "OT",
                    ellipsis: true,
                    width: 100,
                    render: (text, record) => {
                        const otValue = record.weekends[date.Weekend]?.OT || "0"  // Default to '0' if not available
                        return otValue;
                    },
                    onCell: (record) => ({
                        record,
                        dataIndex: record.weekends[date.Weekend]?.OT,
                        title: "OT",
                        key: record.id,
                    }),
                },
                {
                    title: "DT",
                    ellipsis: true,
                    key: "DT",
                    width: 100,
                    render: (text, record) => {
                        const dtValue = record.weekends[date.Weekend]?.DT || "0"  // Default to '0' if not available
                        return dtValue;
                    },
                    onCell: (record) => ({
                        record,
                        dataIndex: record.weekends[date.Weekend]?.DT,
                        title: "DT",
                        key: record.id,
                    }),
                },
                {
                    title: "STATUS",
                    ellipsis: true,
                    key: "STATUS",
                    width: 100,
                    render: (text, record) => {
                        const stValue = record.weekends[date.Weekend]?.Status || ""  // Default to '0' if not available
                        return stValue;
                    },
                    onCell: (record) => ({
                        record,
                        dataIndex: record.weekends[date.Weekend]?.Status,
                        title: "STATUS",
                        key: record.id,
                    }),
                },
            ],
        })),
        // {
        //     title: 'OTHER HOURS',
        //     key: 'Other_Hours',
        //     dataIndex: 'Other_Hours',
        //     // editable: true,
        //     width: 120
        // },
        {
            title: 'RT TOTAL HOURS',
            key: 'RT_Total_Hours',
            dataIndex: 'RT_Total_Hours',
            // editable: true,
            width: 180
        },
        {
            title: 'OT TOTAL HOURS',
            key: 'OT_Total_Hours',
            dataIndex: 'OT_Total_Hours',
            // editable: true,
            width: 180
        },
        {
            title: 'TOTAL HOURS',
            key: 'Worked_Hours',
            dataIndex: 'Worked_Hours',
            // editable: true,
            width: 180
        },
        {
            title: 'REGULAR PAY RATE',
            key: 'Pay_rate',
            dataIndex: 'Pay_rate',
            // editable: true,
            width: 180
        },
        {
            title: 'OT PAY RATE',
            key: 'OT_Pay_rate',
            dataIndex: 'OT_Pay_rate',
            // editable: true,
            width: 180
        },
        {
            title: 'RT AMOUNT',
            key: 'RT_Amount',
            dataIndex: 'RT_Amount',
            // editable: true,
            width: 180
        },
        {
            title: 'OT AMOUNT',
            key: 'OT_Amount',
            dataIndex: 'OT_Amount',
            // editable: true,
            width: 180
        },
        {
            title: 'TOTAL AMOUNT',
            key: 'Invoice_Amount',
            dataIndex: 'Invoice_Amount',
            // editable: true,
            width: 180
        },
        {
            title: 'REGULAR HOURLY RATE',
            key: 'Hourlyrate',
            dataIndex: 'Hourlyrate',
            editable: true,
            width: 180,
            onCell: (record) => ({
                record,
                inputType: 'number',
                dataIndex: 'Hourlyrate',
                title: 'Hourly Rate',
                editing: isEditing(record),
              }),
        },
        {
            title: 'OT HOURLY RATE',
            key: 'Hourly_OT_Pay_rate',
            dataIndex: 'Hourly_OT_Pay_rate',
            editable: true,
            width: 180,
            onCell: (record) => ({
    record,
    inputType: 'number',
    dataIndex: 'Hourly_OT_Pay_rate',
    title: 'OT Hourly Rate',
    editing: isEditing(record),
  }),
        },
        {
            title: 'RT INVOICE HOURS',
            key: 'RT_Invoice_Hours',
            dataIndex: 'RT_Invoice_Hours',
            editable: true,
            width: 180,
            onCell: (record) => ({
                record,
                inputType: 'number',
                dataIndex: 'RT_Invoice_Hours',
                title: 'RT Invoice Hours',
                editing: isEditing(record),
              }),
        },
        {
            title: 'OT INVOICE HOURS',
            key: 'OT_Invoice_Hours',
            dataIndex: 'OT_Invoice_Hours',
            editable: true,
            width: 180,
            onCell: (record) => ({
                record,
                inputType: 'number',
                dataIndex: 'OT_Invoice_Hours',
                title: 'OT Invoice Hours',
                editing: isEditing(record),
              }),
        },
        {
            title: 'TOTAL INVOICE HOURS',
            key: 'Total_Invoice_Hours',
            dataIndex: 'Total_Invoice_Hours',
            editable: true,
            width: 180
        },
        {
            title: 'TOTAL RT AMOUNT',
            key: 'Total_RT_Amount',
            dataIndex: 'Total_RT_Amount',
            editable: true,
            width: 180
        },
        {
            title: 'TOTAL OT AMOUNT',
            key: 'Total_OT_Amount',
            dataIndex: 'Total_OT_Amount',
            editable: true,
            width: 180
        },
        {
            title: 'TOTAL INVOICE AMOUNT',
            key: 'Total_Invoice_Amount',
            dataIndex: 'Total_Invoice_Amount',
            editable: true,
            width: 195
        },
        
        {
            title: 'INVOICE NUMBER',
            key: 'Invoice_Number',
            dataIndex: 'Invoice_Number',
            editable: true,
            width: 180,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        // {
        //     title: 'INVOICE HOURS',
        //     key: 'Invoice_Hrs',
        //     dataIndex: 'Invoice_Hrs',
        //     editable: true,
        //     width: 180
        // },
        // {
        //     title: 'INVOICE AMOUNT',
        //     key: 'HourlyRate_Amount',
        //     dataIndex: 'HourlyRate_Amount',
        //     editable: true,
        //     width: 180
        // },
        {
            title: 'DOCUMENT DATE',
            key: 'Invoice_Date',
            width: 180,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <DatePicker value={documnetDate} onChange={changeDocumentDate} format={"MM-DD-YYYY"} />
                    </span>
                ) : (
                    <div>
                        {record.Invoice_Date}
                    </div>
                );
            },
        },
        {
            title: 'DUE DATE',
            key: 'Due_Date',
            width: 180,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <DatePicker value={fromDate} onChange={changeStartDate} format={"MM-DD-YYYY"} />
                    </span>
                ) : (
                    <div>
                        {record.Due_Date}
                    </div>
                );
            },
        },
        {
            title: 'TEXT',
            key: 'Text',
            dataIndex: 'Text',
            width: 300,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        // {
        //     title: 'COMMENTS',
        //     key: 'Comments',
        //     dataIndex: 'Comments',
        //     editable: true,
        //     width: 180
        // },
        {
            title: 'DOWNLOAD DATE',
            key: 'DownloadDate',
            dataIndex: 'DownloadDate',
            // editable: true,
            width: 180
        },
        {
            title: 'IS VALIDATED',
            key: 'IsValidated',
            // dataIndex: 'IsValidated',
            fixed: 'right',
            // editable: true,
            width: 170,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            style={{
                                marginRight: 8,
                            }}
                        >
                            <Tooltip title={
                                <span
                                    className="placeholder-span"
                                    style={{ color: "#ffff" }}
                                >
                                    Validate
                                </span>
                            } color={"#108ee9"} key={"#108ee9"}>
                                {validateSpin ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7, color: "#3B52DF" }} spin />} />
                                    : <CheckCircleOutlined style={{ color: "green", fontSize: 20, marginRight: "5px" }} onClick={() => validateData(record)} />}
                            </Tooltip>
                        </Typography.Link>
                    </span>
                ) : (
                    <div>
                        {record.IsValidated}
                    </div>
                );
            },
        },
        {
            title: 'ACTION',
            dataIndex: 'action',
            fixed: 'right',
            width: 100,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Popconfirm title="Sure to save?" onConfirm={() => editTableRowData(record)}
                            onCancel={cancel}>
                            <Typography.Link
                                style={{
                                    marginRight: 8,
                                }}
                            >
                                <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                            </Typography.Link>
                        </Popconfirm>
                        <Typography.Link onClick={() => cancel()}>
                            <CloseOutlined style={{ color: "red" }} />
                        </Typography.Link>

                    </span>
                ) : (
                    <div>
                        {record.IsValidated === "Yes" ?
                            <Tooltip title={
                                <span
                                    className="placeholder-span"
                                    style={{ color: "#ffff" }}
                                >
                                    A validated record shouldn't be editable.
                                </span>
                            } color={"#108ee9"} key={"#108ee9"}>
                                <Typography.Link onClick={() => edit(record)} disabled >
                                    <Image
                                        src="/Images/editicon.svg"
                                        style={{
                                            border: "none",
                                            width: "100% ",
                                            marginRight: 5
                                        }}
                                        showPreviewIcon={false}
                                        preview={false}
                                    />
                                </Typography.Link>
                            </Tooltip> : <Typography.Link onClick={() => edit(record)} disabled={editingKey !== ''} >
                                <Image
                                    src="/Images/editicon.svg"
                                    style={{
                                        border: "none",
                                        width: "100% ",
                                        marginRight: 5
                                    }}
                                    showPreviewIcon={false}
                                    preview={false}
                                />
                            </Typography.Link>}
                        {/* <Popconfirm
                            title="Are you sure want to delete?"
                            onConfirm={() => deleteGridRow(record)}
                            okText="Yes"
                            cancelText="No">
                            <Typography.Link>
                                <Image
                                    src="./Images/deleteicon.svg"
                                    style={{
                                        border: "none",
                                        width: "100% ",
                                        marginLeft: 5
                                    }}
                                    showPreviewIcon={false}
                                    preview={false}
                                />
                            </Typography.Link>
                        </Popconfirm> */}
                    </div>

                );
            },
        },
    ]
    const validateData = async (record) => {
        try {
            setValidateSpin(true);
    
            // Send validation request to backend
            const updateresponse = await ValidateRecord(record);
            console.log("Backend Response:", updateresponse.data);
    
            if (!updateresponse || !updateresponse.data || updateresponse.data.statusCode !== 200) {
                throw new Error("Invalid response from server");
            }
    
            // Ensure fresh data retrieval after validation
            let res;
            if (!selectedYearMonth) {
                res = await getPayrollData();
            } else {
                const [year, month] = selectedYearMonth.split("-");
                const prop = `${month}/${year}`;
                res = await getPayrollData(prop);
            }
    
            console.log("Fetched Payroll Data:", res);
    
            if (Array.isArray(res) && res.length > 0 && Array.isArray(res[0])) {
                setGriddata(res[0].map((row, index) => ({ ...row, key: index })));
                setWeekendDates(Array.isArray(res[1]) ? res[1] : []);
            } else {
                setGriddata([]);
                setWeekendDates([]);
            }
            
           
    
            SuccessMessage(updateresponse.data.message);
        } catch (err) {
            console.error("Validation Error:", err);
            ErrorMessage("Cannot validate the record");
        } finally {
            setValidateSpin(false);
            setEditingKey("");
            setFromDate();
            setDocumentDate();
            setStartDate();
            setEndDate();
        }
    };
    
    
    const validateMultipleData = async () => {
        try {
            setValidateLoader(true);
            const updateresponse = await ValidateRecord(selectedValidatedRows);
    
            console.log("Backend Response:", updateresponse.data);
    
            if (updateresponse.data.statusCode === 200) {
                let res;
    
                if (!selectedYearMonth) {
                    res = await getPayrollData();
                } else {
                    const [year, month] = selectedYearMonth.split("-");
                    const prop = `${month}/${year}`;
                    res = await getPayrollData(prop);
                }
    
                console.log("Fetched Payroll Data:", res);
    
                if (Array.isArray(res) && res.length > 0 && Array.isArray(res[0])) {
                    setGriddata(res[0].map((row, index) => ({ ...row, key: index })));
                    setWeekendDates(Array.isArray(res[1]) ? res[1] : []);
                } else {
                    setGriddata([]);
                    setWeekendDates([]);
                }
                
    
                SuccessMessage(updateresponse.data.message);
            } else if (updateresponse.data.statusCode === 500) {
                ErrorMessage(updateresponse.data.message);
            } else {
                ErrorMessage("Cannot validate, please try again");
            }
        } catch (error) {
            console.error("Validation Error:", error);
            ErrorMessage("Cannot validate");
        } finally {
            setValidateLoader(false);
            setSelectedRowKeys([]);
            setSelectedRows([]);
        }
    };
    
    
    const edit = (record) => {
        // setRowData(record)
        let formattedStartDate = "";
        let formattedEndDate = "";
        if (record.Invoice_Date !== undefined) {
            if (record.Invoice_Date !== "") {
                if (record.Invoice_Date !== null) {
                    const defaultValue = dayjs(record.Invoice_Date, 'M/D/YYYY');
                    setDocumentDate(defaultValue)
                    setEndDate("")
                    const [month, day, year] = record.Invoice_Date.split('/');
                    // Convert to integer to remove leading zeros and rearrange to M/D/YYYY format
                    formattedStartDate = `${parseInt(month)}/${parseInt(day)}/${year}`;
                    // rowData.Project_Start = formattedDate;
                }
            }
        }
        if (record.Due_Date !== undefined) {
            if (record.Due_Date !== "") {
                if (record.Due_Date !== null) {
                    const defaultEndValue = dayjs(record.Due_Date, 'M/D/YYYY');
                    setFromDate(defaultEndValue)
                    setStartDate("")
                    const [month, day, year] = record.Due_Date.split('/');
                    // Convert to integer to remove leading zeros and rearrange to M/D/YYYY format
                    formattedEndDate = `${parseInt(month)}/${parseInt(day)}/${year}`;
                }
            }
        }
        setRowData({ ...record, Invoice_Date: formattedStartDate, Due_Date: formattedEndDate })
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.id);
        // console.log(rec)
    }
    const compareObjects = (obj1, obj2) => {
        // Get the keys of both objects
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        // If the number of keys is different, the objects are not the same
        if (keys1.length !== keys2.length) {
            return false;
        }
        // Compare each key
        for (const key of keys1) {
            // Check if the key exists in both objects
            if (keys2.includes(key)) {
                const value1 = obj1[key];
                const value2 = obj2[key];

                // Check if either value1 or value2 is null or undefined
                if (value1 == null || value2 == null) {
                    if (value1 !== value2) {
                        return false; // If one is null and the other is not, return false
                    }
                    continue; // If both are null or undefined, they are considered equal
                }

                // If both values are objects, recursively compare them
                if (typeof value1 === 'object' && typeof value2 === 'object') {
                    if (!compareObjects(value1, value2)) {
                        return false; // If nested objects are not equal, return false
                    }
                }
                // For primitive values, do a direct comparison
                else if (value1 !== value2) {
                    return false; // If values are different, return false
                }
            } else {
                return false; // If key is not in both objects, return false
            }
        }
        return true; // If all keys and values match, return true
    };

    const compareLists = (rowData, currentRowData) => {
        // Make sure the inputs are objects
        if (typeof rowData !== 'object' || typeof currentRowData !== 'object') {
            return false;
        }

        // Use the compareObjects function to compare both rowData and currentRowData
        const result = compareObjects(rowData, currentRowData);
        return result;
    };

    function formatDateToYYYYMMDD(date) {
        const [month, day, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    const editTableRowData = async (props) => {
        try {
            const currentRowData = await form.getFieldValue();
            const tempPS = currentRowData.Due_Date
            const tempPE = currentRowData.Invoice_Date
            if (startDate !== undefined) {
                if (startDate !== "") {
                    const newD = parseInt(startDate.getMonth() + 1) + '/' + parseInt(startDate.getDate()) + '/' + parseInt(startDate.getFullYear());
                    currentRowData.Due_Date = newD;
                }
                else if (startDate === "") {
                    const [month, day, year] = currentRowData.Due_Date.split('/');
                    const newProjectStart = `${parseInt(month)}/${parseInt(day)}/${year}`;
                    currentRowData.Due_Date = newProjectStart;
                }
            }
            else if (startDate === undefined) {
                currentRowData.Due_Date = ""
            }
            if (endDate !== undefined) {
                if (endDate !== "") {
                    const newD = parseInt(endDate.getMonth() + 1) + '/' + parseInt(endDate.getDate()) + '/' + parseInt(endDate.getFullYear());
                    currentRowData.Invoice_Date = newD;
                }
                else if (endDate === "") {
                    const [month, day, year] = currentRowData.Invoice_Date.split('/');
                    const newProjectEnd = `${parseInt(month)}/${parseInt(day)}/${year}`;
                    currentRowData.Invoice_Date = newProjectEnd;
                }
            }
            else if (endDate === undefined) {
                currentRowData.Invoice_Date = ""
            }
             // Invoice Amount Calculation
             const rth = parseFloat(currentRowData.RT_Invoice_Hours) || 0;
             const oth = parseFloat(currentRowData.OT_Invoice_Hours) || 0;
             const rtRate = parseFloat(currentRowData.Hourlyrate) || 0;
             const otRate = parseFloat(currentRowData.Hourly_OT_Pay_rate) || 0;
             
             // Calculate as float, then round to 2 decimals and convert to string
             const totalInvoiceHours = rth + oth;
             const totalRTAmount = rth * rtRate;
             const totalOTAmount = oth * otRate;
             const totalInvoiceAmount = totalRTAmount + totalOTAmount;
             
             // Set as string with 2 decimals
             currentRowData.Total_Invoice_Hours = totalInvoiceHours.toFixed(2);
             currentRowData.Total_RT_Amount = totalRTAmount.toFixed(2);
             currentRowData.Total_OT_Amount = totalOTAmount.toFixed(2);
             currentRowData.Total_Invoice_Amount = totalInvoiceAmount.toFixed(2);
             
            const comparision = compareLists(rowData, currentRowData);
            if (comparision === false) {
                const data = {
                    "id": currentRowData.id,
                    "client_Type": currentRowData.Client_Type,
                    "client": currentRowData.Client,
                    "payroll_Name": currentRowData.Payroll_Name,
                    "weekend": formatDateToYYYYMMDD(currentRowData.Weekend),
                    "WeekStartDate": formatDateToYYYYMMDD(currentRowData.WeekStartDate),
                    "rt": currentRowData.RT,
                    "ot": currentRowData.OT,
                    "dt": currentRowData.DT,
                    "total_Hours": currentRowData.Worked_Hours,
                    "rT_Total_Hours": currentRowData.RT_Total_Hours,
                    "oT_Total_Hours": currentRowData.OT_Total_Hours,
                    "pay_Amount": currentRowData.Pay_Amount,
                    "rT_Amount": currentRowData.RT_Amount,
                    "oT_Amount": currentRowData.OT_Amount,
                    "pay_rate": currentRowData.Pay_rate,
                    "oT_Pay_rate": currentRowData.OT_Pay_rate,
                    "status": currentRowData.Status,
                    "Other_Hours": currentRowData.Other_Hours,
                    "invoice_Date": currentRowData.Invoice_Date,
                    // "invoice_Hrs": currentRowData.Invoice_Hrs,
                     "invoice_Number": currentRowData.Invoice_Number,
                    "invoice_Amount": currentRowData.Invoice_Amount,
                    "due_Date": currentRowData.Due_Date,
                    "worked_Hours": currentRowData.Worked_Hours,
                    "text": currentRowData.Text,
                    "comments": currentRowData.Comments,
                    // "workTimeEntry_date": currentRowData.WorkTimeEntry_date,
                    "hourlyRate_Amount": currentRowData.HourlyRate_Amount,
                    "isValidated": currentRowData.IsValidated,
                    "workerCode": currentRowData.WorkerCode,
                    "hourlyrate": currentRowData.Hourlyrate,
                    "hourly_OT_Pay_rate": currentRowData.Hourly_OT_Pay_rate,
                    // "downloadDate": "2024-10-14T13:05:41.570Z",
                    "userName": currentRowData.UserName,
                    
                // New fields from invoice calculation
                "RT_Invoice_Hours": currentRowData.RT_Invoice_Hours,
                "OT_Invoice_Hours": currentRowData.OT_Invoice_Hours,
                "Total_Invoice_Hours": currentRowData.Total_Invoice_Hours,
                "Total_RT_Amount": currentRowData.Total_RT_Amount,
                "Total_OT_Amount": currentRowData.Total_OT_Amount,
                "Total_Invoice_Amount": currentRowData.Total_Invoice_Amount,
                }
                console.log("updated row:",data);
                const updateresponse = await updateMFRow(data)
                if (updateresponse.data.statusCode === 200) {
                   
                    let res;

                    if (!selectedYearMonth) {
                        // If no date is selected, call API without date
                        res = await getPayrollData();
                    } else {
                        // If a date is selected, call API with date
                        const [year, month] = selectedYearMonth.split("-");
                        const prop = `${month}/${year}`;
                        res = await getPayrollData(prop);
                    }
                    // const res = await getPayrollData(prop)
                    if (Array.isArray(res) && res.length > 0 && Array.isArray(res[0])) {
                        setGriddata(res[0].map((row, index) => ({ ...row, key: index })));
                        setWeekendDates(Array.isArray(res[1]) ? res[1] : []);
                    } else {
                        setGriddata([]);
                        setWeekendDates([]);
                    }
                    
                    if (res[0].length === 0) {
                        setGriddata([])
                        setWeekendDates([])
                    }
                    SuccessMessage(updateresponse.data.message)
                }
                else if (updateresponse.data.statusCode === 500) {
                    InfoMessage(updateresponse.data.message)
                }
                else {
                    ErrorMessage("Cannot able to update, please try again")
                }
                setEditingKey("");
                setFromDate()
                setDocumentDate()
                setStartDate()
                setEndDate()
            }
            else {
                currentRowData.Due_Date = tempPS
                currentRowData.Invoice_Date = tempPE
                InfoMessage("No changes made. Edit and try again.")
            }
        }
        catch (err) {
            setFromDate()
            setDocumentDate()
            setStartDate()
            setEndDate()
            return err
        }
    }
    const cancel = () => {
        setEditingKey("");
        setFromDate()
        setDocumentDate()
        setStartDate()
        setEndDate()
    }
    const deleteGridRow = (record) => {
        setEditingKey("");
    }
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                // inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    // const onSelectChange = (newSelectedRowKeys,newSelectedRows) => {
    //     setSelectedRowKeys(newSelectedRowKeys);
    //     setSelectedRows(newSelectedRows);
    //     setSelectedValidatedRows(newSelectedRows);
    //     console.log("Selected Rows:", newSelectedRows);
    // };
    const refreshDataMethod = async () => {
        try {
            setSyncSpin(true)
            setTableLoader(true)
            const res = await downloadMontlyData(null);
            if (res !== null && res.length > 0) {
                if (res[0] !== null && res[0] !== null) {
                    setGriddata(res[0])
                    setWeekendDates(res[1])
                }
            }
            if (res[0].length === 0) {
                setGriddata([])
                setWeekendDates([])
            }
            setSyncSpin(false)
            setTableLoader(false)
        }
        catch {
            setSyncSpin(false)
            setTableLoader(false)
        }
    }
    const getMontlyData = async (prop) => {
        try {
            setMonthLoader(true)
            setTableLoader(true)
            const res = await downloadMontlyData(prop);
            if (res !== null && res.length > 0) {
                if (res[0] !== null && res[0] !== null) {
                    setGriddata(res[0])
                    setWeekendDates(res[1])
                }
            }
            if (res[0].length === 0) {
                setGriddata([])
                setWeekendDates([])
            }
            setMonthLoader(false)
            setTableLoader(false)
        }
        catch {
            setMonthLoader(false)
            setTableLoader(false)
        }
    }
    // const rowSelection = {
    //     selectedRowKeys,
    //     selectedRows,
    //     onChange: onSelectChange,
    // };
    const selectMonth = async (date, dateString) => {
        try {
            if (!dateString) return;
    
            setMonthLoader(true);
            setTableLoader(true);
            setSelectedYearMonth(dateString)
            const [year, month] = dateString.split("-");
            const prop = `${month}/${year}`;
            setSelectedMonthYear(prop);
            console.log("selectedmothyear",selectedMonthYear)
    
            const res = await downloadMontlyData(prop);
    
            if (Array.isArray(res) && res.length > 0 && Array.isArray(res[0])) {
                setGriddata(res[0].map((row, index) => ({ ...row, key: index })));
                setWeekendDates(Array.isArray(res[1]) ? res[1] : []);
            } else {
                setGriddata([]);
                setWeekendDates([]);
            }
            
    
            setMonthLoader(false);
            setTableLoader(false);
        } catch {
            setMonthLoader(false);
            setTableLoader(false);
        }
    };
    
    return (<>
        <div className="mfrow-tnn">
            <Input
                placeholder="Search Portal \ Client \ Payroll Name"
                className="MFten-searchrow"
                onChange={(e) => setSearchRow(e.target.value)}
                allowClear
                suffix={
                    <SearchOutlined
                        style={{ color: "#7185FF", justifyContent: "space-between" }}
                    />
                }
            />
            {/* {syncSpin ?
                <Spin indicator={<ReloadOutlined style={{ fontSize: 18, marginLeft: 10, color: "#3B52DF" }} spin />} /> :
                <Tooltip title={
                    <span
                        className="placeholder-span"
                        style={{ color: "#ffff" }}
                    >
                        Refresh data
                    </span>
                } color={"#108ee9"} key={"#108ee9"}>
                    <ReloadOutlined style={{ fontSize: 18, marginLeft: 10, color: "#3B52DF", cursor: "pointer" }}
                        onClick={refreshDataMethod} />
                </Tooltip>} */}
            <div style={{ display: "flex", alignItems: "center", paddingRight: 10 }}>
                {/* <DatePicker onChange={selectYear} picker="year" /> */}
                <DatePicker onChange={selectMonth} picker="month" style={{ marginLeft: 15 }} />
            </div>
        </div>
        {selectedValidatedRows.length > 0 ? <Button style={{ marginRight: "5px", marginTop: 10 }} onClick={() => validateMultipleData()}
            loading={validateLoader} className="validate-row-1099">Validate</Button>
            : null}
        <div className={griddata.length > 0 ? "ten99-table-class" : "ten99-empty-table"} style={{ marginTop: 10 }}>
            {
                tableLoader ?
                    <Spin tip="Loading...">
                        <Form form={form} component={false}>
                            <Table
                                className="ten99-table"
                                rowClassName="editable-row"
                                columns={mergedColumns}
                                dataSource={originalData.map(item => ({ ...item, key: item.id }))}
                                components={{ body: { cell: EditableCell, }, }}
                                bordered
                                rowSelection={rowSelection}
                                scroll={{ x: 1500, y: 400 }}
                            // pagination
                            /> </Form> </Spin> :
                    griddata.length > 0 ? < Form form={form} component={false} >
                        <Table
                            className="ten99-table"
                            rowClassName="editable-row"
                            columns={mergedColumns}
                            dataSource={originalData.map(item => ({ ...item, key: item.id }))}
                            components={{ body: { cell: EditableCell, }, }}
                            bordered
                            rowSelection={rowSelection}
                            scroll={{ x: 1500, y: 400 }}
                        />
                    </Form> : < Form form={form} component={false} >
                        <Table
                            className="ten99-table"
                            rowClassName="editable-row"
                            columns={mergedColumns}
                            dataSource={originalData.map(item => ({ ...item, key: item.id }))}
                            components={{ body: { cell: EditableCell, }, }}
                            bordered
                            rowSelection={rowSelection}
                            scroll={{ x: 400, y: 400 }}
                        />
                    </Form>
            }
        </div>
        {/* <div className="crawl-prepare-row">
            <Button className="crawl-prepare-button">Crawl & Prepare</Button>
        </div> */}
    </>)
}
export default MasterfileTable;
